export enum UserRole {
  DRIVER = 'driver',
  RIDER = 'rider',
  ADMIN = 'admin',
}
